<div *ngIf="item" class="container-fluid">
  <div *ngIf="item.item_ID">
    <div mat-dialog-title i18n>Edit Item</div>
    <div class="form-inline mb-2">
      <span class="col-xs-12" i18n>Make the necessary changes on the form below then click Submit</span>
      <div class="float-right form-inline">
        <div class="col-xs-12">
          <span class="col-xs-12 col-sm-4 warning" i18n>* Required Information</span>
          <div class="float-right" *ngIf="canDeleteItem">
            <button (click)="deleteItem(item.item_ID)" class="btn btn-bidit-cancel btn-sm" type="button" i18n>Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!item.item_ID">
    <div mat-dialog-title i18n>Add Item</div>
    <div class="form-inline row mb-2">
      <span class="col-sm-8" i18n>To add a new Item, complete the form below then click Submit.</span>
      <span class="float-right warning col-sm-4" i18n>* Required Information</span>
    </div>
  </div>

  <form #form="ngForm" (ngSubmit)="saveItem(form)">
    <mat-dialog-content class="row">
      <div class="form-group form-inline">
        <span class="warning">* </span>
        <label class="pr-3" for="item_Name" i18n>Name</label>
        <input id="item_Name" name="item_Name" class="col-md-6 form-control" [(ngModel)]="item.item_Name"
               required #item_Name="ngModel"
               [class.field-error]="form.submitted && item_Name.invalid">
      </div>
      <div [hidden]="!form.submitted || item_Name.valid"
           class="col-10 alert alert-danger" i18n>Name is required</div>

      <div class="form-group form-inline">
        <label for="item_SalesDesc" class="pr-2" i18n>Sales Description</label>
        <textarea id="item_SalesDesc" name="item_SalesDesc" type="text"
                  placeholder="Sales Description"
                  i18n-placeholder
                  class="col form-control"
                  [(ngModel)]="item.item_SalesDesc"
                  #item_SalesDesc="ngModel">
          </textarea>
      </div>
      <div class="form-group form-inline">
        <span class="warning">* </span>
        <label class="pr-3" for="itemTypes" i18n>Item Type</label>

        <div *ngIf="this.item?.itemType?.itemCoverageType_ID != coverageEnum.AeroBarrier">
          <select name="itemTypes" id="itemTypes" class="form-control select-bidit" (ngModelChange)="onItemTypeChange($event)" [(ngModel)]="item.itemType_ID"
                  required #itemTypes="ngModel">
            <option [ngValue]="null" selected="">-</option>
            <option *ngFor="let type of itemTypesFiltered" [(ngValue)]="type.itemType_ID" [disabled]="!type.itemType_IsActive">{{type.itemType_Desc}}</option>
          </select>
          <div [hidden]="!form.submitted || itemTypes.valid"
               class="row alert alert-danger" i18n>Item Type is required</div>
        </div>

        <div *ngIf="this.item?.itemType?.itemCoverageType_ID == coverageEnum.AeroBarrier">
          <select [disabled]="true" name="itemTypes" id="itemTypes" class="form-control select-bidit" (ngModelChange)="onItemTypeChange($event)" [(ngModel)]="item.itemType_ID"
                  required #itemTypes="ngModel">
            <option [ngValue]="null" selected="">-</option>
            <option *ngFor="let type of itemTypes" [(ngValue)]="type.itemType_ID">{{type.itemType_Desc}}</option>
          </select>
          <div row [hidden]="!form.submitted || itemTypes.valid"
               class="alert alert-danger" i18n>Item Type is required</div>
        </div>

        <div *ngIf="item?.itemType?.itemCoverageType_ID == null">
          <label class="px-3" for="rValues" i18n>R Value</label>
          <select name="rValues" id="rValues" class="form-control select-bidit" [(ngModel)]="item.rValue_ID">
            <option [ngValue]="null" selected="">-</option>
            <option *ngFor="let rvalue of rValues" [(ngValue)]="rvalue.rValue_ID">{{rvalue.rValue_Desc}}</option>
          </select>
        </div>
      </div>

      <div *ngIf="!showItemCoverage && !showAeroBarrier" class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span *ngIf="itemTypeRequired" class="warning">* </span>
            <label class="pr-3" for="item_SqrFtPerUnit" i18n>Square Feet Per Unit</label>
            <input type="number" step="0.01" min="0" id="item_SqrFtPerUnit" (ngModelChange)="calculateCostUnit()"
                   name="item_SqrFtPerUnit" class="form-control" [(ngModel)]="item.item_SqrFtPerUnit"
                   required="{{itemTypeRequired}}" #item_SqrFtPerUnit="ngModel"
                   [class.field-error]="form.submitted && item_SqrFtPerUnit.invalid">
            <div [hidden]="!form.submitted || item_SqrFtPerUnit.valid"
                 class="alert alert-danger" i18n>Square feet per unit is required</div>
          </div>
        </div>
      </div>
      <div *ngIf="!showItemCoverage && !showAeroBarrier && item.itemType != null && !item.itemType.itemType_IsAccessory" class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="pr-3" for="item_Cost_SqrFt" i18n>Item Cost Per Sqr Ft</label>
            <input type="number" step="0.01" min="0" id="item_Cost_SqrFt" name="item_Cost_SqrFt" class="form-control"
                   [(ngModel)]="item.item_Cost_SqrFt"
                   required #item_Cost_SqrFt="ngModel" (ngModelChange)="calculateCostUnit()"
                   [class.field-error]="form.submitted && item_Cost_SqrFt.invalid">
            <div [hidden]="!form.submitted || item_Cost_SqrFt.valid"
                 class="alert alert-danger" i18n>Item Cost is required</div>
          </div>

        </div>
        <div style="padding-left: 100px;" i18n>- OR -</div>
      </div>
      <div *ngIf="showAeroBarrier">
        <div class="form-group row">
          <div class="col-md-12 form-inline">
            <div class="control-wrapper">
              <span *ngIf="itemTypeRequired" class="warning">* </span>
              <label class="pr-3" for="item_SqrFt_Upto" i18n>SQFT up to</label>
              <input type="number" step="0.01" min="0" id="item_SqrFtUpto"
                     name="item_SqrFt_Upto" class="form-control" [(ngModel)]="item.item_SqrFt_Upto"
                     required="{{itemTypeRequired}}" #item_SqrFt_Upto="ngModel" [disabled]="true"
                     [class.field-error]="form.submitted && item_SqrFt_Upto.invalid">
              <div [hidden]="!form.submitted || item_SqrFt_Upto.valid"
                   class="alert alert-danger" i18n>SQFT up to is required</div>
            </div>
          </div>
        </div>
        <div class="form-group form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="pr-3" for="item_Cost_SqrFt">
              <span i18n>Item Cost Per Sqr Ft </span>
            </label>
            <input type="number" step="0.01" min="0" id="item_Cost_SqrFt" name="item_Cost_SqrFt" class="form-control"
                   [(ngModel)]="item.item_Cost_SqrFt" (ngModelChange)="calculateCost()" [disabled]="true"
                   required #item_Cost="ngModel"
                   [class.field-error]="form.submitted && item_Cost_SqrFt.invalid">
            <div [hidden]="!form.submitted || item_Cost_SqrFt.valid"
                 class="col-md-12 alert alert-danger" i18n>Item Cost is required</div>
          </div>
        </div>
        <div class="form-group form-inline">
          <div class="control-wrapper">
            <label class="pr-3" for="item_Cost_SqrFt_Overrage">
              <span i18n>Item Cost Per Sqr Ft Overrage </span>
            </label>
            <input type="number" step="0.01" min="0" id="item_Cost_SqrFt_Overrage" name="item_Cost_SqrFt_Overrage" class="form-control"
                   [(ngModel)]="item.item_Cost_SqrFt_Overrage" [disabled]="true">
          </div>
        </div>
      </div>
      <div *ngIf="!showAeroBarrier" class="form-group form-inline">
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label class="pr-3" for="item_Cost">
            <span i18n>Item Cost Per </span>
            <ng-container [ngSwitch]="item.itemType?.itemCoverageType_ID">
              <ng-container *ngSwitchCase="1" i18n>Bag</ng-container>
              <ng-container *ngSwitchCase="2" i18n>Set</ng-container>
              <ng-container *ngSwitchCase="3" i18n>Sqr Ft</ng-container>
              <ng-container *ngSwitchDefault i18n>Unit</ng-container>
            </ng-container>
          </label>
          <input type="number" step="0.01" min="0" id="item_Cost" name="item_Cost" class="form-control"
                 [(ngModel)]="item.item_Cost"
                 required #item_Cost="ngModel" (ngModelChange)="calculateCostSqFt()"
                 [class.field-error]="form.submitted &&item_Cost.invalid">
          <div [hidden]="!form.submitted || item_Cost.valid"
               class="col-md-12 alert alert-danger" i18n>Item Cost is required</div>
        </div>
      </div>
      <div *ngIf="!isItemPartReadOnly" class="form-group form-inline">
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label class="pr-3" for="item_Part" i18n>Manufacturer Part #</label>
          <input id="item_Part" name="item_Part" class="form-control" [(ngModel)]="item.item_Part"
                 required
                 #item_Part="ngModel"
                 [class.field-error]="form.submitted && item_Part.invalid" disabled="{{isItemPartReadOnly}}">
          <div [hidden]="!form.submitted || item_Part.valid || isItemPartReadOnly"
               class="alert alert-danger" i18n>Part number is invalid</div>
        </div>
      </div>
      <div *ngIf="isItemPartReadOnly && item.external_Item_Part === null && item.item_IDIPart" class="form-group form-inline">
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label class="pr-3" for="item_Part" i18n>Manufacturer Part #</label>
          <input id="item_IDIPart" name="item_IDIPart" class="form-control" [(ngModel)]="item.item_IDIPart"
                 item_IDIPart="ngModel"
                 disabled="disabled">
        </div>
      </div>
      <div *ngIf="isItemPartReadOnly && item.external_Item_Part !== null" class="form-group form-inline">
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label class="pr-3" for="external_Item_Part" i18n>Manufacturer Part #</label>
          <input id="external_Item_Part" name="external_Item_Part" class="form-control" [(ngModel)]="item.external_Item_Part"
                 external_Item_Part="ngModel"
                 disabled="disabled">
        </div>
      </div>
      <div class="form-group form-inline">
        <label class="pr-3" for="Item_Qty_Onhand" i18n>QTY on Hand</label>
        <input id="item_Qty_Onhand" name="item_Qty_Onhand" type="number" class="form-control" [(ngModel)]="item.item_Qty_Onhand"
               #item_Qty_Onhand="ngModel"
               [class.field-error]="form.submitted && item_Qty_Onhand">
        <div [hidden]="!form.submitted || item_Qty_Onhand.valid"
             class="alert alert-danger" i18n>QTY on Hand is invalid</div>
      </div>
      <div *ngIf="showItemCoverage">
        <div class="card bg-calculate mb-3">
          <div class="card-body">
            <div *ngIf="item?.itemType?.itemCoverageType_ID == coverageEnum.Blow" class="mb-2" i18n>Item Coverage defines the square coverage of blow by R-Value.</div>
            <div *ngIf="item?.itemType?.itemCoverageType_ID == coverageEnum.Inches">
              <div class="mb-2" i18n>Item Coverage defines the square coverage of spray foam by inches.</div>
              <div class="form-group form-inline">
                <div class="form-inline col-6">
                  <label class="mr-2" for="coveragePerSet" i18n>Coverage Per Set </label>
                  <input type="number" class="form-control" id="coveragePerSet" name="coveragePerSet" validate="float"
                         [(ngModel)]="itemCoverageData.coveragePerSet" #sqrFt="ngModel" />
                </div>
                <div class="col-6">
                  <img (click)="calcItemCoverages(itemCoverageData)" src="assets/img/circle_images/quotes_circle.png" alt="Calculate Icon" /><br />
                  <span i18n>Calculate</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div *ngFor="let iu of itemCoverageData.itemUsages  | slice:0:(itemCoverageData.columnEntries)">
                  <div class="form-group form-inline">
                    <label class="col-sm-4" for="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}">{{iu.rValue.rValue_Desc}}</label>
                    <input type="hidden" value={{iu.itemUsage_ID}}>
                    <input type="hidden" value={{iu.item_ID}}>
                    <input type="hidden" value={{iu.rValue_ID}}>
                    <input type="number" class="form-control col-sm-8" id="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}" min="0" name="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}" validate="float"
                           [(ngModel)]="iu.itemUsage_SqrFtg" #sqrFt="ngModel" />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div *ngFor="let iu of itemCoverageData.itemUsages  | slice:itemCoverageData.columnEntries:(itemCoverageData.columnEntries*2)">
                  <div class="form-group form-inline">
                    <label class="col-sm-4" for="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}">{{iu.rValue.rValue_Desc}}</label>
                    <input type="hidden" value={{iu.itemUsage_ID}}>
                    <input type="hidden" value={{iu.item_ID}}>
                    <input type="hidden" value={{iu.rValue_ID}}>
                    <input type="number" class="form-control  col-sm-8" id="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}" min="0" name="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}" validate="float"
                           [(ngModel)]="iu.itemUsage_SqrFtg" #sqrFt="ngModel" />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div *ngFor="let iu of itemCoverageData.itemUsages  | slice:(itemCoverageData.columnEntries*2):itemCoverageData.itemUsages.length">
                  <div class="form-group form-inline">
                    <label class="col-sm-4" for="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}">{{iu.rValue.rValue_Desc}}</label>
                    <input type="hidden" value={{iu.itemUsage_ID}}>
                    <input type="hidden" value={{iu.item_ID}}>
                    <input type="hidden" value={{iu.rValue_ID}}>
                    <input type="number" class="form-control  col-sm-8" id="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}" min="0" name="{{iu.rValue_ID}}_{{iu.itemUsage_SqrFtg}}" validate="float"
                           [(ngModel)]="iu.itemUsage_SqrFtg" #sqrFt="ngModel" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-inline">
        <label class="pr-3" for="vendorSelect" i18n>Default Vendor</label>
        <select name="vendorSelect" id="vendorSelect" class="form-control select-bidit" [(ngModel)]="item.item_DefVendor">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let vendor of vendors" [(ngValue)]="vendor.vendor_ID">{{vendor.vendor_BusinessName}}</option>
        </select>
      </div>
      <div class="form-group form-inline">
        <label class="pr-3" for="warehouseSelect" i18n>Default Warehouse</label>
        <select name="warehouseSelect" id="warehouseSelect" class="form-control select-bidit" [(ngModel)]="item.item_DefWarehouse">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let warehouse of warehouses" [(ngValue)]="warehouse.warehouse_ID">{{warehouse.warehouse_Name}}</option>
        </select>
      </div>

    </mat-dialog-content>
    <mat-dialog-actions align-item-end class="mb-1">
      <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </mat-dialog-actions>
    <app-spinner [isRunning]="isRequesting"></app-spinner>

    <div [hidden]="!form.submitted || form.valid"
         class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
  </form>

</div>
